var klaviyo = klaviyo || [];
    klaviyo.init({
      account: "Rx7dRj",
      list: "QQ4aVE",
      platform: "shopify"
    });
    klaviyo.enable("backinstock",{ 
    trigger: {
      product_page_text: "DE - Notify Me When Available",
      product_page_class: "btn",
      product_page_text_align: "center",
      product_page_margin: "0px",
      replace_anchor: false
    },
    modal: {
     headline: "{product_name}",
     body_content: "Inscrivez-vous pour être averti lorsque l'article sera de nouveau en stock.",
     email_field_label: "E-mail",
     button_label: "Épuisé - Prévenez-moi",
     subscription_success_label: "Nous vous informerons lorsqu'il sera de retour.",
     newsletter_subscribe_label: "Ajoutez-moi à votre liste de diffusion.",
     subscribe_checked: true,
     footer_content: '',
     additional_styles: `
      @import url('https://fonts.googleapis.com/css2?family=Nunito+Sans'); 

      #klaviyo-bis-modal .btn-success { 
        border-radius: 8px; 
        background-color: #bf3c68;
        border-color: #bf3c68;
        font-weight: 400; 
        padding: .75em 1em;
      }

      #klaviyo-bis-modal #email { 
        border-radius: 8px; 
        border: 1px solid #E8E2DF; 
        background: #fff; 
        color: #171717; 
        padding: .75em 1em; 
      }

      #klaviyo-bis-modal #variants { 
        border-radius: 8px; 
        border: 1px solid #E8E2DF; 
        background: #fff; 
        color: #171717; 
        padding: .75em 1em; 
      }

      #klaviyo-bis-modal #container { border-radius: 8px; }
    `,
     drop_background_color: "#000",
     background_color: "#fff",
     text_color: "#222",
     button_text_color: "#fff",
     button_background_color: "#439fdb",
     close_button_color: "#ccc",
     error_background_color: "#fcd6d7",
     error_text_color: "#C72E2F",
     success_background_color: "#d3efcd",
     success_text_color: "#1B9500",
     close_label: "Fermer" 
    }
  });